module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "frequently-asked"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.discussionFaqTitle'),
      "subTitle": _vm.$t('message.discussionFaqSubTitle')
    }
  }), _vm._v(" "), _c('mu-list', [(_vm.isLoading === true) ? _c('div', _vm._l((5), function(item, index) {
    return _c('mu-list-item', {
      key: 'dummy-loader' + index
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "width": "16%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return (_vm.isLoading === false) ? _c('mu-list-item', {
      key: 'frequent-question-' + index,
      staticClass: "faq",
      attrs: {
        "title": _vm.encode(item.question)
      },
      on: {
        "click": function($event) {
          return _vm.goToQuestion(item.question_id)
        }
      }
    }) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c82c7d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Questions/FrequentlyAsked/FrequentlyAsked.vue
// module id = 3129
// module chunks = 1